(function () {
    'use strict';

    angular
        .module('searchV2Module')
        .config(['searchV2ServiceProvider', function (searchV2ServiceProvider) {

            searchV2ServiceProvider.setStateParamsConfig({
                q: { value: undefined }
            });

            searchV2ServiceProvider.stateParamsToSourceQueryParamsTransformers.push(function (stateParams, searchSource) {
                searchSource.queryParams.q = stateParams.q;
            });

            searchV2ServiceProvider.searchResultToContextTransformers.push(function (searchCtxt, stateParams) {
                searchCtxt.q = stateParams.q;
            });
        }])
        .directive('searchBox', directive);

    directive.$inject = [];

    function directive() {
        return {
            restrict: 'AE',
            scope: {
                searchCtxt: '=',
                version: '=?',
                placeholder: '@?'
            },
            template: '<div ng-include="getTemplateUrl()"></div>',
            controller: ['$scope', 'searchV2Service', function ($scope, searchV2Service) {
                var MIN_QUERY_LENGTH = 2;

                $scope.getTemplateUrl = function () {
                    if (_.isUndefined($scope.version)) $scope.version = 'default';

                    return  '/app/shared/searchV2/searchBox-' + $scope.version + '.tpl.html';
                };

                $scope.onSearchQueryChange = function () {
                    if (_.isUndefined($scope.searchCtxt)) return;

                    if (!_.isUndefined($scope.searchCtxt.q) &&
                            $scope.searchCtxt.q.length > 0 &&
                            $scope.searchCtxt.q.length < MIN_QUERY_LENGTH) {
                        return;
                    }

                    searchV2Service
                        .search({
                            q: $scope.searchCtxt.q
                        }).then(function (searchCtxt) {
                            $scope.searchCtxt = searchCtxt;
                        });;
                };

                $scope.resetSearch = function () {
                    searchV2Service
                        .search({
                            q: undefined,
                            sourceType: undefined
                        }).then(function (searchCtxt) {
                            $scope.searchCtxt = searchCtxt;
                        });
                };

            }]
        };
    }

})();